import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { OsLotReviewsPage } from '@contracts';

export const Route = createFileRoute('/_app/os/lot-reviews')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.OsLotReviews);
  },
  validateSearch: z.object({
    clause: z.enum(['gp', 'new']).optional().catch('gp'),
    campaign_year: z.coerce.number().int().optional().catch(undefined),
  }),
  component: OsLotReviewsPage,
  errorComponent: OsLotReviewsPage.Error,
});
